// /frontend/src/pages/dashboard/post/tiktok/TikTokOptionsDrawer.js  (v2.0 – modernized UI)
// All logic identical to v1.
import React, { useState } from 'react';

const VISIBILITY_OPTS = [
  { key: 'public',  label: 'Public',  icon: 'fas fa-globe' },
  { key: 'friends', label: 'Friends', icon: 'fas fa-user-friends' },
  { key: 'private', label: 'Private', icon: 'fas fa-lock' },
];

/* Reusable toggle switch */
function Toggle ({ id, checked, onChange, label }) {
  return (
    <label htmlFor={id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', cursor:'pointer', padding:'8px 0', borderBottom:'1px solid #f9fafb' }}>
      <span style={{ fontSize:13, fontWeight:500, color:'#374151' }}>{label}</span>
      <div
        id={id}
        onClick={() => onChange(!checked)}
        style={{
          width:36, height:20, borderRadius:99, position:'relative', flexShrink:0,
          background: checked ? '#2563eb' : '#d1d5db', transition:'background 0.2s', cursor:'pointer',
        }}
      >
        <div style={{
          position:'absolute', top:2, left: checked ? 18 : 2, width:16, height:16,
          borderRadius:'50%', background:'#fff', transition:'left 0.2s',
          boxShadow:'0 1px 3px rgba(0,0,0,0.2)',
        }} />
      </div>
    </label>
  );
}

export default function TikTokOptionsDrawer ({ tiktokAccounts = [], updateAccountOption, files = [] }) {
  const [open, setOpen] = useState(true);
  if (!tiktokAccounts.length) return null;

  const setOption = (acc, patch) => updateAccountOption(acc.id, acc.platform, { ...patch });

  return (
    <div style={{ background:'#ffffff', border:'1px solid #e5e7eb', borderRadius:12, marginBottom:12, overflow:'hidden', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' }}>
      {/* Header */}
      <button
        type='button'
        onClick={() => setOpen(o => !o)}
        style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', background:'transparent', border:'none', cursor:'pointer' }}
      >
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:26, height:26, borderRadius:'50%', background:'#f0fafa', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            <i className='fab fa-tiktok' style={{ fontSize:12, color:'#000000' }} />
          </div>
          <span style={{ fontSize:13, fontWeight:700, color:'#111827' }}>TikTok Options</span>
        </div>
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`} style={{ fontSize:11, color:'#9ca3af' }} />
      </button>

      {/* Body */}
      {open && (
        <div style={{ padding:'4px 16px 16px', borderTop:'1px solid #f3f4f6' }}>
          {tiktokAccounts.map(acc => {
            const vis        = acc.options?.visibility       ?? 'public';
            const comments   = acc.options?.allowComments    ?? true;
            const duet       = acc.options?.allowDuet        ?? true;
            const isBranded  = acc.options?.isBrandedContent ?? false;
            const isOrganic  = acc.options?.isOrganicBranded ?? false;

            return (
              <div key={acc.id} style={{ marginTop:12 }}>
                {tiktokAccounts.length > 1 && (
                  <div style={{ fontSize:12, fontWeight:600, color:'#6b7280', marginBottom:10 }}>{acc.displayName}</div>
                )}

                {/* Visibility pills */}
                <div style={{ marginBottom:14 }}>
                  <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em', color:'#9ca3af', marginBottom:8 }}>Visibility</div>
                  <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                    {VISIBILITY_OPTS.map(opt => {
                      const isActive = vis === opt.key;
                      return (
                        <button
                          key={opt.key}
                          type='button'
                          onClick={() => setOption(acc, { visibility: opt.key })}
                          style={{
                            display:'flex', alignItems:'center', gap:6,
                            padding:'6px 12px', borderRadius:8,
                            border:`1.5px solid ${isActive ? '#2563eb' : '#e5e7eb'}`,
                            background: isActive ? '#eff6ff' : '#ffffff',
                            color: isActive ? '#2563eb' : '#374151',
                            fontSize:12, fontWeight: isActive ? 700 : 500,
                            cursor:'pointer', transition:'all 0.15s',
                          }}
                        >
                          <i className={opt.icon} style={{ fontSize:10 }} />
                          {opt.label}
                        </button>
                      );
                    })}
                  </div>
                </div>

                {/* Toggles */}
                <div style={{ marginBottom:12 }}>
                  <Toggle id={`tt-comments-${acc.id}`} checked={comments} label='Allow comments'
                    onChange={v => setOption(acc, { allowComments: v })} />
                  <Toggle id={`tt-duets-${acc.id}`} checked={duet} label='Allow duets / stitches'
                    onChange={v => setOption(acc, { allowDuet: v })} />
                </div>

                {/* Branded content */}
                <div style={{ background:'#f8fafc', border:'1px solid #e5e7eb', borderRadius:8, padding:'10px 12px' }}>
                  <div style={{ fontSize:11, fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em', color:'#9ca3af', marginBottom:8 }}>Branded Content</div>
                  <Toggle id={`tt-branded-${acc.id}`} checked={isBranded} label='This is a paid partnership'
                    onChange={v => setOption(acc, { isBrandedContent: v })} />
                  <Toggle id={`tt-organic-${acc.id}`} checked={isOrganic} label='This promotes my own brand'
                    onChange={v => setOption(acc, { isOrganicBranded: v })} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}